import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import HdPageLoader from "@hd/ui-kit/hd-page-loader/HdPageLoader";

const LeisureReportsPage = lazy(
  () => import("./pages/leisure-reports/LeisureReportsPage")
);
function useReportsRoutes() {
  return (
    <Route
      path="leisure-reports/*"
      element={
        <Suspense fallback={<HdPageLoader />}>
          <LeisureReportsPage />
        </Suspense>
      }
    />
  );
}

export default useReportsRoutes;